// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"237":"pages","409":"my","970":"payments"}[chunkId] + "." + {"237":"25704160","409":"8211f9bd","970":"7e13fd91"}[chunkId] + ".css";
};